// 菜单显示规则：有title，并且 hiddenInMenu不为ture
export function isCanShow(obj = {}) {
  if (obj.alwaysShow) {
    return !obj.hiddenInMenu;
  }
  return !obj.hiddenInMenu && obj.meta && obj.meta.title;
}
export function filterRouter(routers = []) {
  const res = [];
  routers.forEach((first) => {
    if (isCanShow(first)) {
      // eslint-disable-next-line no-param-reassign
      first.children = first.children || [];
      const child = [];
      first.children.forEach((second) => {
        // eslint-disable-next-line no-unused-expressions
        (isCanShow(second) || first.alwaysShow) && (child.push(second));
      });
      // eslint-disable-next-line no-param-reassign
      first.children = child;
      res.push(first);
    }
  });
  return res;
}
